import { AnyAction } from 'redux';

import { driversActions } from '../reducer';

export const resetDriverFuelAssignments = (): AnyAction => driversActions.resetDriverFuelAssignments();
